import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/upload.png'
import _imports_1 from '@/assets/icon/off.png'


const _withScopeId = n => (_pushScopeId("data-v-0bf9715e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publish_demand" }
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { class: "upload_div" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tit" }, [
  /*#__PURE__*/_createTextVNode("上传图片"),
  /*#__PURE__*/_createElementVNode("span", null, "最多上传9张图片，单张图片大小不超过5MB")
], -1))
const _hoisted_5 = { class: "uploat_wrap" }
const _hoisted_6 = {
  key: 0,
  class: "preview_img"
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "van-badge__wrapper van-icon van-icon-cross van-uploader__preview-delete-icon" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload_img",
  fit: "cover",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload_img",
  fit: "cover",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = {
  class: "upload_div",
  style: {"border":"none"}
}
const _hoisted_14 = { class: "tit" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 上传附件")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最多上传5个文件，单个文件大小不超过100MB", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "fileList_preview_text" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "footer_one" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("发布信息")

import { ref, onMounted } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import Cities from "@/components/Cities.vue"
import { areaList } from "@vant/area-data"
import { publishApi, getDetailApi, updatePublishApi, getOffDetailApi } from "@/api/projectDemand"
import { dicAPi, uploadApi, msgSecCheckAPi } from "@/api/login"
import commons from "@/utils/commons"
import {
  showSuccessToast,
  showFailToast,
  showLoadingToast,
  closeToast,
  showNotify,
  showImagePreview,
  showToast
} from "vant"
import DataList from "@/api/common"

export default /*#__PURE__*/_defineComponent({
  __name: 'publishDemand',
  setup(__props) {

const route = useRoute()
const formData: any = ref({
  xqbt: "",
  pictureFiles: [],
  fjFiles: []
})
const show = ref(false)
const showType = ref(false)
const imgList: any = ref([])
const fileList = ref([])
const showArea = ref(false)
const columns = ref([]) //资源类型
const szcsbmLabel = ref("")
const xqlxName = ref() //需求类型展示使用
const isSafe = ref(0) //是否通过安全检测
const xqlxList = ref([
  { text: "寻找资产", value: "0" },
  { text: "我有资产", value: "1" }
])
const onAreaConfirm = (e: any) => {
  szcsbmLabel.value = e.selectedOptions[0]?.text + "/" + e.selectedOptions[1]?.text + "/" + e.selectedOptions[2]?.text
  showArea.value = false
  formData.value.szcsbm = e.selectedValues.join(",")
}
const onConfirm = (e: any) => {
  formData.value.zylx = e.selectedValues[0]
  show.value = false
  console.log(e.selectedValues[0])
}
const onConfirmType = (e: any) => {
  console.log(e)
  formData.value.xqlx = e.selectedValues[0]
  xqlxName.value = xqlxList.value[e.selectedIndexes[0]].text
  showType.value = false
}
onMounted(() => {
  getAllDict() //获取字典
  if (route.query.id) {
    getDtail(route.query.id)
    formData.value.xqbt = ""
    formData.value.xqms = ""
    formData.value.lxfs = ""
    xqlxName.value = ""
    formData.value.xqlx = ""
    formData.value.zylx = ""
    formData.value.szcsbm = ""
    imgList.value = []
    formData.value.pictureFiles = []
    fileList.value = []
    formData.value.fjFiles = []
  }
})
// 获取详情
const getDtail = async (id: any) => {
  showLoadingToast({
    message: "加载中"
  })
  getOffDetailApi(id).then((res: any) => {
    closeToast()
    console.log(res)
    if (res.code == 200) {
      formData.value.xqbt = res.data.xqbt
      formData.value.xqms = res.data.xqms
      formData.value.lxfs = res.data.lxfs
      xqlxName.value = res.data.xqlx === "1" ? "我有资产" : "寻找资产"
      formData.value.xqlx = res.data.xqlx
      formData.value.zylx = res.data.zylx
      formData.value.szcsbm = res.data.szcsbm
      if (res.data.lxfs) {
        isSafe.value = 3
        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&")
        console.log(isSafe.value)
      } else {
        console.log("##########################&&&&&&&&&&&&&&&&&&&&&&&&&&&")
        isSafe.value = 2
        console.log(isSafe.value)
      }
      if (res.data.pictureFilesDetail && res.data.pictureFilesDetail.length > 0) {
        imgList.value = res.data.pictureFilesDetail || []
        formData.value.pictureFiles = res.data.pictureFilesDetail.map((item: any) => {
          return item.sfid
        })
      }
      if (res.data.fjFilesDetail) {
        fileList.value = res.data.fjFilesDetail.map((item: any) => {
          return item.fileName
        })
        formData.value.fjFiles = res.data.fjFilesDetail.map((item: any) => {
          return item.sfid
        })
      }
      closeToast()
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("resource_type")
  if (res.code == 200) {
    columns.value = res.data
  }
}
// 获取图片地址
const getimgUrl = (item: any) => {
  if (item) {
    const url = DataList.UpdtImagePrefix() + item.sfid
    return url
  }
}
// 编辑上传图片预览图片
const previewImg = (index: any) => {
  const list = imgList.value.map((item: any) => {
    return DataList.UpdtImagePrefix() + item.sfid
  })
  showImagePreview({
    images: list,
    startPosition: index
  })
}
// 图片上传
const afterReadImg = (event: any) => {
  showLoadingToast({
    message: "上传中"
  })
  const formDatas = new FormData()
  formDatas.append("file", event.file) // 追加文件
  uploadApi(formDatas).then((res: any) => {
    closeToast()
    if (res.code == 200 && res.sucess) {
      formData.value.pictureFiles.push(res.data.sfid)
      var index = imgList.value?.length - 1
      imgList.value[index]["sfid"] = res.data.sfid
      closeToast()
      showNotify({ type: "success", message: "上传成功" })
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 图片删除
const imgRemove = (event: any) => {
  var deleteSfid = event.sfid
  for (let i = 0; i < formData.value.pictureFiles?.length; i++) {
    const item = formData.value.pictureFiles[i]
    console.log(item)
    if (!!deleteSfid && item) {
      if (deleteSfid == item) {
        formData.value.pictureFiles.splice(i, 1)
      }
    }
  }
}
const onDelImg = (index: any) => {
  formData.value.pictureFiles.splice(index, 1)
  imgList.value.splice(index, 1)
}
// 附件上传
const afterReadFile = (event: any) => {
  showLoadingToast({
    message: "上传中"
  })
  fileList.value.push(event.file?.name)
  const formDatas = new FormData()
  formDatas.append("file", event.file) // 追加文件
  uploadApi(formDatas).then((res: any) => {
    closeToast()
    if (res.code == 200 && res.sucess) {
      formData.value.fjFiles.push(res.data.sfid)
      closeToast()
      showNotify({ type: "success", message: "上传成功" })
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 附件删除
const fileRemove = (index: number) => {
  formData.value.fjFiles.splice(index, 1)
  fileList.value.splice(index, 1)
}
const onOverSizeFile = (file: any) => {
  showNotify({ type: "warning", message: "单个文件大小不超过100MB" })
}
const onOverSizeImg = (file: any) => {
  showNotify({ type: "warning", message: "单张图片大小不超过5MB" })
}
// 提交时间
const onSubmit = async () => {
  const newUrl = route.query.id ? updatePublishApi : publishApi
  if (!formData.value.szcsbm) {
    showNotify({ type: "warning", message: "请选择城市" })
  } else {
    route.query.id ? (formData.value.sfid = route.query.id) : ""
    showLoadingToast({
      message: "发布中"
    })
    if (isCheckSafe.value >= 1) {
      showToast("请先进行安全检测！！！")
      return false
    } else if (formData.value.lxfs && isSafe.value < 3) {
      showToast("包含不符合相关规定的敏感信息！！！")
      return false
    } else if (!formData.value.lxfs && isSafe.value < 2) {
      showToast("包含不符合相关规定的敏感信息！！！")
      return false
    } else {
      newUrl(formData.value).then((res: any) => {
        if (res.code == 200) {
          closeToast()
          showNotify({ type: "success", message: "发布成功" })
          //   跳转
          // router.push({ path: "/projectDemand" })
          if (route.query.id) {
            router.go(-1)
          } else {
            router.push({ path: "/projectDemand" })
          }
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    }
  }
}
// 安全检测
const isCheckSafe = ref(0) //是否需要进行安全检测
const onBlur = async (val: any, type: number) => {
  if (val) {
    msgSecCheckAPi({
      content: val,
      openId: localStorage.getItem("openId"),
      scene: 3
    }).then((res: any) => {
      if (res.code == 200) {
        if (res.data.suggest != "pass") {
          showToast("包含不符合相关规定的敏感信息！！！")
          // 清空敏感词
          // type == 1
          //   ? (formData.value.xqbt = "")
          //   : type == 2
          //   ? (formData.value.xqms = "")
          //   : type == 3
          //   ? (formData.value.lxfs = "")
          //   : ""
        } else if (res.data.suggest == "pass") {
          isSafe.value += 1
        }
      } else {
        isCheckSafe.value += 1
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
const reSearch = () => {}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: onSubmit,
      class: "van-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: formData.value.xqbt,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.xqbt) = $event)),
          name: "需求标题",
          label: "需求标题",
          class: "requird",
          maxlength: "100",
          placeholder: "好的标题更能引起注意",
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (onBlur(formData.value.xqbt, 1))),
          rules: [{ required: true, message: '请输入标题' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          class: "input_2 requird",
          modelValue: formData.value.xqms,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.xqms) = $event)),
          name: "需求描述",
          label: "需求描述",
          maxlength: "2000",
          type: "textarea",
          autoSize: "",
          rows: "4",
          "show-word-limit": "",
          placeholder: "请输入需求描述",
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (onBlur(formData.value.xqms, 2))),
          rules: [{ required: true, message: '请输入需求描述' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          class: "input_2",
          modelValue: formData.value.lxfs,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.lxfs) = $event)),
          name: "联系方式",
          label: "联系方式",
          maxlength: "300",
          autoSize: "",
          rows: "4",
          type: "textarea",
          placeholder: "请留下联系方式方便联系",
          "show-word-limit": "",
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (onBlur(formData.value.lxfs, 3)))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: "",
          clickadle: "",
          name: "xqlx",
          modelValue: xqlxName.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((xqlxName).value = $event)),
          label: "需求类型",
          placeholder: "请选择",
          "is-link": "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (showType.value = true)),
          class: "set_arrow",
          rules: [{ required: true, message: '请选择' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_popup, {
          show: showType.value,
          "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showType).value = $event)),
          position: "bottom",
          style: { width: '100%' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              columns: xqlxList.value,
              onConfirm: onConfirmType,
              onCancel: _cache[8] || (_cache[8] = ($event: any) => (showType.value = false))
            }, null, 8, ["columns"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_van_field, {
          readonly: "",
          clickadle: "",
          name: "area",
          modelValue: formData.value.zylx,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.zylx) = $event)),
          label: "选择类型",
          placeholder: "请选择",
          "is-link": "",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (show.value = true)),
          class: "set_arrow",
          rules: [{ required: true, message: '请选择' }]
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_popup, {
          show: show.value,
          "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((show).value = $event)),
          position: "bottom",
          style: { width: '100%' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_picker, {
              "columns-field-names": { text: 'name', value: 'code' },
              columns: columns.value,
              onConfirm: onConfirm,
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (show.value = false)),
              onChange: _ctx.onChange
            }, null, 8, ["columns", "onChange"])
          ]),
          _: 1
        }, 8, ["show"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_field, {
            readonly: "",
            clickadle: "",
            name: "area",
            modelValue: formData.value.szcsbm,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.szcsbm) = $event)),
            label: "选择城市",
            "is-link": "",
            placeholder: "",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (showArea.value = true)),
            class: "set_arrow"
          }, null, 8, ["modelValue"]),
          _createVNode(Cities, {
            city: formData.value.szcsbm,
            "onUpdate:city": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.szcsbm) = $event)),
            level: 3,
            isAll: true,
            onChange: _cache[17] || (_cache[17] = ($event: any) => (reSearch()))
          }, null, 8, ["city"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_unref(route).query.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "item_img",
                      key: index
                    }, [
                      (getimgUrl(item)?.split('?sfid=')[1] != 'undefined')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "home_img",
                            fit: "cover",
                            src: getimgUrl(item),
                            alt: "",
                            onClick: ($event: any) => (previewImg(index))
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "del_img",
                        onClick: ($event: any) => (onDelImg(index))
                      }, _hoisted_10, 8, _hoisted_8)
                    ]))
                  }), 128)),
                  _createVNode(_component_van_uploader, {
                    style: {"width":"61px","height":"68px"},
                    modelValue: imgList.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((imgList).value = $event)),
                    multiple: "",
                    "max-size": 5 * 1024 * 1024,
                    "preview-image": _unref(route).query.id ? false : true,
                    "max-count": 9,
                    "after-read": afterReadImg,
                    accept: ".jpg, .png , .jpeg ",
                    onOversize: onOverSizeImg,
                    onDelete: imgRemove,
                    "before-read": _unref(commons).beforeReadImg
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["modelValue", "preview-image", "before-read"])
                ]))
              : (_openBlock(), _createBlock(_component_van_uploader, {
                  key: 1,
                  modelValue: imgList.value,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((imgList).value = $event)),
                  multiple: "",
                  "max-size": 5 * 1024 * 1024,
                  "max-count": 9,
                  "after-read": afterReadImg,
                  accept: ".jpg, .png , .jpeg ",
                  onOversize: onOverSizeImg,
                  onDelete: imgRemove,
                  "before-read": _unref(commons).beforeReadImg
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["modelValue", "before-read"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("i", null, _toDisplayString(fileList.value?.length) + "/5", 1)
          ]),
          _createVNode(_component_van_uploader, {
            multiple: "",
            disabled: fileList.value?.length >= 5 ? true : false,
            "max-count": 5,
            "max-size": 100 * 1024 * 1024,
            "preview-image": false,
            accept: ".doc, .docx , .pdf, .ppt,zip, .rar , .excel ",
            "after-read": afterReadFile,
            onOversize: onOverSizeFile,
            "before-read": _unref(commons).beforeReadFile
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_button, {
                color: "#ffcd01",
                type: "primary",
                icon: "plus",
                class: "upload_files"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["disabled", "before-read"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "fileList_preview",
              onClick: ($event: any) => (_unref(commons).downloadAttachment(formData.value.fjFiles[index], item))
            }, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(item), 1),
              _createElementVNode("img", {
                fit: "cover",
                src: _imports_1,
                alt: "",
                onClick: ($event: any) => (fileRemove(index))
              }, null, 8, _hoisted_20)
            ], 8, _hoisted_18))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_button, {
            round: "",
            color: "#ffcd01",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})